import { render, staticRenderFns } from "./WAvatar.vue?vue&type=template&id=c67d92f0&scoped=true&"
import script from "./WAvatar.vue?vue&type=script&lang=js&"
export * from "./WAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67d92f0",
  null
  
)

export default component.exports